// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__XYAJq","portal":"styles_portal__soLm9","anchor":"styles_anchor__cqTOE"};